import { useNavigate } from "react-router-dom";
import { havingDeletePermission } from "@/utility/common";
import { GetCommonDeleteImgButton, GetCommonDownArrowImgButton, GetCommonUpArrowImgButton } from "@/components/Images/CommonImages";

export const useCustomCellRenderers = ({
	handleDeleteEvent,
	schemeName,
	handleShiftRow,
	Rule,
	setDeleteEntityName
}: {
	handleDeleteEvent: (ruleId: string) => void;
	schemeName: string;
	handleShiftRow: (rowIndex: number, direction: "up" | "down") => void;
	Rule: string[];
	setDeleteEntityName: any;
}) => {
	const navigate = useNavigate();
	const caseRenderers = {
		nameCellRenderers: function (param: any) {
			const { isDraft } = param;
			return (
				<div
				style={{ cursor: "pointer" }}
					onClick={() => {
						const ruleId = param.data.id;
								const className = param.data.className;
								navigate(`./edit-rule/${ruleId}?className=${className}&schemeName=${schemeName}&isDraft=${isDraft}`, {
									state: { ruleId, className, schemeName,isDraft },
								});
							
					}}
				>
					{param.data.name}
				</div>
			);
		},
		actionCellRenderers: function (param: any) {
			return (
				<div className="motif-row">
					{havingDeletePermission(Rule) && (
						<GetCommonDeleteImgButton onClick={() => {
							handleDeleteEvent(param.data.id);
							setDeleteEntityName(param.data.name)
						}}></GetCommonDeleteImgButton>
						// <div className="motif-col-lg-6">
						// 	<CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
						// 	<MotifButton
						// 		size="small"
						// 		variant={DELETE_IMG_VARIANT}
						// 		onClick={() => {
						// 			handleDeleteEvent(param.data.id);
						// 			setDeleteEntityName(param.data.name)
						// 		}}
						// 	>
						// 		{getCommonDeleteImg()}
						// 	</MotifButton>
						// 	</CommonTooltipWrapper>
						// </div>
					)}
				</div>
			);
		},
		sortingCellRenderers: function (param: any) {
			const { isDraft } = param;
			return havingDeletePermission(Rule) ? (
				 <>
						  <GetCommonUpArrowImgButton
						disabled={!isDraft}
						onClick={() => handleShiftRow(param.rowIndex, "up")}
						  ></GetCommonUpArrowImgButton>
						  <GetCommonDownArrowImgButton
						onClick={() => handleShiftRow(param.rowIndex, "down")}
						disabled={!isDraft}
						  ></GetCommonDownArrowImgButton>
						</>
				// <div className="motif-row">
				// 	<div className="motif-col-lg-6">
				// 		<CommonTooltipWrapper tooltipTitle={t("global.globalActions.moveUp")}>
				// 		<MotifButton
				// 			size="small"
				// 			variant="secondary"
				// 			type="button"
				// 			disabled={!isDraft}
				// 			onClick={() => handleShiftRow(param.rowIndex, "up")}
				// 		>
				// 			<MotifIcon iconFunction={IconoirArrowUp} size="24" />
				// 		</MotifButton>
				// 		</CommonTooltipWrapper>
				// 	</div>
				// 	<div className="motif-col-lg-6">
				// 		<CommonTooltipWrapper tooltipTitle={t("global.globalActions.moveDown")}>
				// 		<MotifButton
				// 			onClick={() => handleShiftRow(param.rowIndex, "down")}
				// 			size="small"
				// 			type="button"
				// 			variant="secondary"
				// 			disabled={!isDraft}
				// 		>
				// 			<MotifIcon iconFunction={IconoirArrowDown} size="24" />
				// 		</MotifButton>
				// 		</CommonTooltipWrapper>
				// 	</div>
				// </div>
			) : (
				<></>
			);
		},
	};
	return caseRenderers;
};
